module.exports = __webpack_public_path__ + "static/media/494.dcfe1040.webp";